import {
  Container,
} from '../styles';

const withMessageContainer = (WrappedComponent) => (
  function WithModalContainer({
    isLoading = false,
    isOpened,
    title,
    ...props
  }) {
    return (
      <Container
        isOpen={isOpened}
        preventScroll
        overlayClassName="Overlay"
        width="720px"
      >
        <WrappedComponent {...props} isLoading={isLoading} />
      </Container>
    );
  }
);

export default withMessageContainer;
